import ContentDetailPageHeader from "../components/common/content/content-detail-page-header";
import ContentHeader from "../components/common/content/content-header";
import { StyledContainer } from "../components/common/content/styles";
import { Typography } from "@mui/material";
import {Seo} from "../seo/Seo";

export default function Calendar() {
  const liturgiesText =
    "Regular Liturgies:\nSunday: 8:00 AM - 12:00 PM";
  const embedUrl =
    "https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=America%2FChicago&src=c3RnZW9yZ2VpbEBnbWFpbC5jb20&color=%234285F4";

  return (
    <>
      <Seo
        title="Calendar"
        description="View liturgies, events, and services at St. George Coptic Orthodox Church in Monee, IL."
        path="/calendar"
      />
      <StyledContainer maxWidth={false}>
        <ContentDetailPageHeader />
        <ContentHeader title="Calendar" />
        <Typography
          color="text.primary"
          variant="body1"
          fontWeight="bold"
          textAlign={"center"}
          whiteSpace="pre-line"
        >
          {liturgiesText}
        </Typography>
        <br />
        <br />
        <iframe
          title="Calendar"
          style={{ border: "0" }}
          src={embedUrl}
          width="100%"
          height="600"
          loading="lazy"
        ></iframe>
      </StyledContainer>
    </>
  );
}
